import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { Language, setLanguage as setGlobalLanguage, initializeLanguage, t } from './index';

interface LanguageContextType {
  language: Language;
  changeLanguage: (lang: Language) => void;
  t: (key: string) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<Language>('ja');

  useEffect(() => {
    // 初期化時に保存された言語設定を読み込み
    initializeLanguage();
    const savedLang = localStorage.getItem('sorarium-language') as Language;
    if (savedLang && (savedLang === 'ja' || savedLang === 'en')) {
      setLanguage(savedLang);
    } else {
      // ブラウザの言語設定から判定
      const browserLang = navigator.language.toLowerCase();
      setLanguage(browserLang.startsWith('ja') ? 'ja' : 'en');
    }
  }, []);

  const changeLanguage = (lang: Language) => {
    setLanguage(lang);
    setGlobalLanguage(lang);
    // リロード不要！
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  }
  return context;
};